import { CadastroBem } from "./cadastro-bem";

export class Arquivo {
  cD_BPM_ARQUIVO_PATRIMONIAL: number;
  dS_BPM_DIRETORIO_ARQUIVO_PATRIMONIAL!:	string;
  dS_BPM_FILENAME_ARQUIVO_PATRIMONIAL!:	string;
  dS_BPM_CONTENT_TYPE_ARQUIVO_PATRIMONIAL!: string;
  cD_BPM_BEM_PATRIMONIAL!:CadastroBem;
  fL_BPM_ATIVO!: number;
  fL_BPM_DELETADO!: number; 
}
